// extracted by mini-css-extract-plugin
export var cardIcon = "_5h-5";
export var cardIconUnframed = "_5h-9";
export var checkboxCard = "_5h-0";
export var checkboxCardSelected = "_5h-4";
export var disabled = "_5h-2";
export var interactive = "_5h-1";
export var outerBorder = "_5h-3";
export var spacerMedium = "_5h-8";
export var spacerSmall = "_5h-7";
export var spacerXsmall = "_5h-6";